<div *ngIf="showName === true || showName == null" [class.mat-subheading-1]="SmallDisplay" class="nobottommargin">
    {{ greeting }}, {{ username }}!
</div>
<div class="role" *ngIf="role && user.Roles.IsMultiRole !== true">{{ role }}</div>
<mat-menu #roleMenu="matMenu">
    <button mat-menu-item *ngIf="user && user.Roles.IsDeveloper" (click)="SwitchRole('Developer')">Developer Access</button>
    <button mat-menu-item *ngIf="user && user.Roles.IsDistrictAdmin" (click)="SwitchRole('DistrictAdmin')">
        District Administrator Access
    </button>
    <button mat-menu-item *ngIf="user && user.Roles.IsAdvisor" (click)="SwitchRole('Advisor')">College Advisor Access</button>
    <button mat-menu-item *ngIf="user && user.Roles.IsCollegeAdmin" (click)="SwitchRole('CollegeAdmin')">
        College Administrator Access
    </button>
    <button mat-menu-item *ngIf="user && user.Roles.IsCollegeSupport" (click)="SwitchRole('CollegeSupport')">
        College Support Staff Access
    </button>
    <button mat-menu-item *ngIf="user && user.Roles.IsCounselor" (click)="SwitchRole('Counselor')">School Counselor Access</button>
    <button mat-menu-item *ngIf="user && user.Roles.IsParent" (click)="SwitchRole('Parent')">Parent Access</button>
    <button mat-menu-item *ngIf="user && user.Roles.IsSchoolAdmin" (click)="SwitchRole('SchoolAdmin')">
        School Administrator Access
    </button>
    <button mat-menu-item *ngIf="user && user.Roles.IsStudent" (click)="SwitchRole('Student')">Student Access</button>
</mat-menu>
<button
    class="menutrigger"
    mat-raised-button
    *ngIf="role && user.Roles.IsMultiRole === true"
    color="primary"
    [matMenuTriggerFor]="roleMenu"
>
    <span>{{ role | roleText }}</span>
    <mat-icon>keyboard_arrow_down</mat-icon>
</button>



// WEBPACK FOOTER //
// ./src/app/userinfo/userinfo.component.html